// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1cTE4","newExpiryDate":"styles_newExpiryDate__TVVxG","footer":"styles_footer__2QTZV"};